import React from 'react';
import Link from 'next/link';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

import Header from '@components/layout/Header';
import SEOHead from '@components/SEOHead';
import Image from '@components/elements/Image';
import { Footer } from '@components/layout/Footer';

import { CtaBtn } from '@components/LandingElements/CtaBtn';

export default function Examples() {
  return (
    <>
      <SEOHead
        title="AI Girl Adventures: Epic Roleplay in GF AI Chat with Dirty Talk"
        description="Check out example dialogues with AI girl and chat in your own style. Bypass character AI filter by using AI Girlfriend WTF, the best c.ai alternative"
        type="website"
        keywords="AI girlfriend, chat with ai girlfriend wtf, sexting ai, free ai girlfriend chat, ai girl chat examples, AI story"
        url="https://www.aigirlfriend.wtf/examples"
        imageUrl="https://www.aigirlfriend.wtf/web-banner-min.jpg"
      />
      <Header />
      <br />
      <br />
      <br />

      <main className="container">
        <h1 className="text-[35px]">
          Craft Epic Adventures with your AI girl, your cutting-edge AI
          companion!
        </h1>
        <h2 className="text-[30px]">
          #1 Manifest your dreams into reality in your gf AI chat 😳
        </h2>
        <p>
          Describe your vision, then sit back and let the AI girl bring it to
          life, crafting your story in real-time. Use asterix to indicate an
          action eg: *I take Elise hand and smile*. This character AI is
          designed to respond dynamically, making each interaction uniquely
          yours.
        </p>
        <img
          src="/examples/event-example.png"
          alt="Screenshot of dialogue with event happening with ai girl"
          width={832}
          height={832}
        />
        <h2 className="text-[30px]">
          #2 &quot;Invite&quot; people into your story as well! 😏
        </h2>
        <p>
          Summon allies or evil villains to your{' '}
          <Link href={'/nsfw-ai-roleplay'} className={'!underline bold'}>
            AI Roleplay
          </Link>{' '}
          tale. Your choice! The flexibility of our character AI allows you to
          weave complex narratives with multiple characters, enriching your
          adventure.
        </p>
        <img
          src="/examples/people-example.png"
          alt="Screenshot of chat with ai girl where new person comes in"
          width={832}
          height={832}
        />
        <h2 className="text-[30px]">
          #3 Take gf AI chat to the next level with dirty talk{' '}
        </h2>
        <p>
          Did you know that our virtual girlfriends are very flirty and will
          support even mature conversations? Well, now you know! Craft a spicy
          story with your virtual partner by introducing some{' '}
          <Link href={'/talk-dirty-ai'} className={'!underline bold'}>
            dirty talk
          </Link>{' '}
          Engage in romantic AI interactions that are both thrilling and
          lifelike, thanks to our cutting-edge technology.
        </p>
        <h2 className="text-[30px]">Learn more about AI Girlfriend chat: </h2>
        <p>
          <Link href="/ai-girlfriend-chat">
            &gt; Read about our roleplay AI chatbot possibilities{' '}
          </Link>
        </p>
        <p>
          <Link href="/ai-sexting">&gt; Learn about sexting AI</Link>
        </p>
        <p>
          <Link href="/yandere-ai">&gt; Yandere simulator</Link>
        </p>
        <p>
          <Link href="/nsfw-ai-generator ">
            &gt; Our NSFW AI Image generator
          </Link>
        </p>
        <h2 className="text-[30px]">
          Check out our AI girl&apos;s spicy image gallery:{' '}
        </h2>
        <ul>
          <li>
            <Link href={'https://www.aigirlfriend.wtf/gallery/mira'}>
              Asian girl Mira&apos;s gallery
            </Link>
          </li>
          <li>
            <Link href={'https://www.aigirlfriend.wtf/gallery/sofia'}>
              Ginger sweetie Sofia&apos;s photos
            </Link>
          </li>
          <li>
            <Link href={'https://www.aigirlfriend.wtf/gallery/irma'}>
              Milf Irma&apos;s gallery
            </Link>
          </li>
          <li>
            <Link href={'https://www.aigirlfriend.wtf/gallery/kali'}>
              Brunet Kali&apos;s gallery
            </Link>
          </li>
          <li>
            <Link href={'https://www.aigirlfriend.wtf/gallery/lucy'}>
              Shy anime girl Lucy&apos;s images
            </Link>
          </li>
          <li>
            <Link href={'https://www.aigirlfriend.wtf/gallery/sydney'}>
              Sexy anime girl Sydney&apos;s images
            </Link>
          </li>
          <li>
            <Link href={'https://www.aigirlfriend.wtf/gallery/sally'}>
              Anime girl Sally&apos;s images
            </Link>
          </li>
          <li>
            <Link href={'https://www.aigirlfriend.wtf/gallery/asuka'}>
              For Evangelion fans Asuka&apos;s images
            </Link>
          </li>
          <li>
            <Link href={'https://www.aigirlfriend.wtf/gallery/irina'}>
              Sporty Irina&apos;s images
            </Link>
          </li>
          <li>
            <Link href={'https://www.aigirlfriend.wtf/gallery/kitty'}>
              Cat girl Kitty&apos;s images
            </Link>
          </li>
          <li>
            <Link href={'https://www.aigirlfriend.wtf/gallery/alina'}>
              Blonde sexy girl Alina&apos;s images
            </Link>
          </li>
          <li>
            <Link href={'https://www.aigirlfriend.wtf/gallery/bertha'}>
              Chubby Bertha&apos;s images
            </Link>
          </li>
        </ul>
        <div className="text-center">
          <h3 className="text-[20px]">
            Can you come up with an awesome adventure?
          </h3>

          <div className="text-center">
            <CtaBtn href={'/ai-girls'} text={'Try Now'} />
          </div>
        </div>
      </main>

      <br />
      <Footer />
    </>
  );
}

export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['header', 'footer'])),
    },
  };
}
